var _rect, _polyline, _path, _path2, _rect2, _path3, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRoomFull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    stroke: "currentColor",
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 28.5,
    width: 31,
    height: 3,
    rx: 1,
    strokeMiterlimit: 10
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "3.5 13.63 3.5 28.5 28.5 28.5 28.5 13.63",
    strokeMiterlimit: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.21,12.35,16.94,1a1.5,1.5,0,0,0-1.88,0L.79,12.35a.78.78,0,0,0-.12,1.09l.73.9a.75.75,0,0,0,1.05.12L15.53,4.18a.75.75,0,0,1,.94,0L29.55,14.46a.75.75,0,0,0,1.05-.12l.73-.9A.78.78,0,0,0,31.21,12.35Z",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5,16.5h-6a1,1,0,0,0-1,1v11h8v-11A1,1,0,0,0,13.5,16.5Z",
    strokeMiterlimit: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 16.5,
    width: 8,
    height: 6,
    rx: 1,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,5.39V1.27A.76.76,0,0,1,23.27.5h3.46a.76.76,0,0,1,.77.77V9.42",
    strokeMiterlimit: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 19.5,
    x2: 25,
    y2: 19.5,
    strokeMiterlimit: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 21.5,
    y1: 16,
    x2: 21.5,
    y2: 23,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoomFull);
export default __webpack_public_path__ + "static/media/icon-room-full.e5e23b330c4d25c10cec0c766e7b33c6.svg";
export { ForwardRef as ReactComponent };